import { Component, inject, OnChanges, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import { GuruEntity } from '../../../../model/guru-entity';
import { ModelService } from '../../../../services/model-service';
import { UserStateService, ConfigurationSection } from '../../../../services/user-state.service';
import { StringUtils } from '../../../../utils/string-utils';
import { SelectionUtils } from '../../../selection-utils';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-swt-com-unit-information',
  imports: [FormsModule, MatIcon],
  templateUrl: './swt-com-unit-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './swt-com-unit-information.component.css'
})
export class SwtComUnitInformationComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  modelSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  voltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  refrigerationSelection!: GuruEntity;
  headerOptionsSelection!: GuruEntity;
  compressorSelection!: GuruEntity;
  compressorSoundOptionsSelection!: GuruEntity;
  electricalOptionsSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.modelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USModel');
    this.sizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
    this.voltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.refrigerationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRefrigerationOptions');
    this.headerOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterOptions');
    this.compressorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCompressor');
    this.compressorSoundOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCompressorSoundOptions');
    this.electricalOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSCCR');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

  isHandArrangementImageAvailable(): boolean {
    return StringUtils.isNotBlank(this.imagePrefix()) && StringUtils.isNotBlank(this.handArrangementImagePath());
  }
}
